'use client';

import { useField } from '@mui/x-date-pickers/internals';
import { useDateRangeManager } from "../managers/index.js";
export const useSingleInputDateRangeField = props => {
  const manager = useDateRangeManager(props);
  return useField({
    manager,
    props
  });
};